import { apibooKey } from '../../services/storageNamespace';

/**
 * Settings → MCP → "Connect your agent": which agent the user picked
 * (owner, 26.10.2026: "ask which agent do you use, claude code, cursor, codex
 * or other and show the terminal command for adding that mcp").
 *
 * Product names are not translated, so the labels live here; only "Other"
 * goes through i18n (`labelKey`).
 */
export const MCP_AGENTS = [
  { id: 'claude-code', label: 'Claude Code' },
  { id: 'cursor', label: 'Cursor' },
  { id: 'codex', label: 'Codex' },
  { id: 'claude-desktop', label: 'Claude Desktop' },
  { id: 'other', labelKey: 'mcp.connectAgentOther' },
];

export const DEFAULT_MCP_AGENT = 'claude-code';

const STORE_SUFFIX = 'mcp-agent-choice';
const known = (id) => MCP_AGENTS.some((a) => a.id === id);

/**
 * Per account (`apibooKey`), per device. A UI convenience, not a setting that
 * has to follow the user around, so plain localStorage: storage that throws
 * (private window, blocked site data) or holds junk falls back to Claude Code.
 */
export function loadAgentChoice() {
  try {
    const raw = localStorage.getItem(apibooKey(STORE_SUFFIX));
    return known(raw) ? raw : DEFAULT_MCP_AGENT;
  } catch {
    return DEFAULT_MCP_AGENT;
  }
}

export function saveAgentChoice(id) {
  if (!known(id)) return;
  try {
    localStorage.setItem(apibooKey(STORE_SUFFIX), id);
  } catch {
    /* the choice still holds for this visit */
  }
}
